import { render } from "./ComponenteMotoresCogeneracion.vue?vue&type=template&id=67b58072&scoped=true"
import script from "./ComponenteMotoresCogeneracion.vue?vue&type=script&lang=js"
export * from "./ComponenteMotoresCogeneracion.vue?vue&type=script&lang=js"

import "./ComponenteMotoresCogeneracion.vue?vue&type=style&index=0&id=67b58072&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b58072"]])

export default __exports__